import { render, staticRenderFns } from "./BestOffer.vue?vue&type=template&id=6cb36c51"
import script from "./BestOffer.vue?vue&type=script&lang=js"
export * from "./BestOffer.vue?vue&type=script&lang=js"
import style0 from "./BestOffer.vue?vue&type=style&index=0&id=6cb36c51&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseProduct: require('/home/korzinka/www/front/components/base/Product.vue').default})
